/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmissionStatusUpdatedByUser } from './PalAuthSubmissionStatusUpdatedByUser';
import {
    PalAuthSubmissionStatusUpdatedByUserFromJSON,
    PalAuthSubmissionStatusUpdatedByUserFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserToJSON,
} from './PalAuthSubmissionStatusUpdatedByUser';
import type { PalSubmissionListEntryLeadWaitlistDetails } from './PalSubmissionListEntryLeadWaitlistDetails';
import {
    PalSubmissionListEntryLeadWaitlistDetailsFromJSON,
    PalSubmissionListEntryLeadWaitlistDetailsFromJSONTyped,
    PalSubmissionListEntryLeadWaitlistDetailsToJSON,
} from './PalSubmissionListEntryLeadWaitlistDetails';
import type { PalSubmissionListEntryLeadWaitlistUpdatesInner } from './PalSubmissionListEntryLeadWaitlistUpdatesInner';
import {
    PalSubmissionListEntryLeadWaitlistUpdatesInnerFromJSON,
    PalSubmissionListEntryLeadWaitlistUpdatesInnerFromJSONTyped,
    PalSubmissionListEntryLeadWaitlistUpdatesInnerToJSON,
} from './PalSubmissionListEntryLeadWaitlistUpdatesInner';

/**
 * 
 * @export
 * @interface PalSubmissionListEntryLeadWaitlist
 */
export interface PalSubmissionListEntryLeadWaitlist {
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadWaitlist
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadWaitlist
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadWaitlist
     */
    status?: PalSubmissionListEntryLeadWaitlistStatusEnum;
    /**
     * 
     * @type {PalSubmissionListEntryLeadWaitlistDetails}
     * @memberof PalSubmissionListEntryLeadWaitlist
     */
    details?: PalSubmissionListEntryLeadWaitlistDetails;
    /**
     * 
     * @type {number}
     * @memberof PalSubmissionListEntryLeadWaitlist
     */
    rank?: number;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadWaitlist
     */
    created_at?: string;
    /**
     * 
     * @type {PalAuthSubmissionStatusUpdatedByUser}
     * @memberof PalSubmissionListEntryLeadWaitlist
     */
    status_set_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadWaitlist
     */
    receipt_id?: string;
    /**
     * 
     * @type {Array<PalSubmissionListEntryLeadWaitlistUpdatesInner>}
     * @memberof PalSubmissionListEntryLeadWaitlist
     */
    updates?: Array<PalSubmissionListEntryLeadWaitlistUpdatesInner>;
}


/**
 * @export
 */
export const PalSubmissionListEntryLeadWaitlistStatusEnum = {
    Waitlisted: 'Waitlisted',
    Cleared: 'Cleared',
    Cancelled: 'Cancelled'
} as const;
export type PalSubmissionListEntryLeadWaitlistStatusEnum = typeof PalSubmissionListEntryLeadWaitlistStatusEnum[keyof typeof PalSubmissionListEntryLeadWaitlistStatusEnum];


/**
 * Check if a given object implements the PalSubmissionListEntryLeadWaitlist interface.
 */
export function instanceOfPalSubmissionListEntryLeadWaitlist(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalSubmissionListEntryLeadWaitlistFromJSON(json: any): PalSubmissionListEntryLeadWaitlist {
    return PalSubmissionListEntryLeadWaitlistFromJSONTyped(json, false);
}

export function PalSubmissionListEntryLeadWaitlistFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntryLeadWaitlist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'details': !exists(json, 'details') ? undefined : PalSubmissionListEntryLeadWaitlistDetailsFromJSON(json['details']),
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'status_set_by_user': !exists(json, 'status_set_by_user') ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['status_set_by_user']),
        'receipt_id': !exists(json, 'receipt_id') ? undefined : json['receipt_id'],
        'updates': !exists(json, 'updates') ? undefined : ((json['updates'] as Array<any>).map(PalSubmissionListEntryLeadWaitlistUpdatesInnerFromJSON)),
    };
}

export function PalSubmissionListEntryLeadWaitlistToJSON(value?: PalSubmissionListEntryLeadWaitlist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'status': value.status,
        'details': PalSubmissionListEntryLeadWaitlistDetailsToJSON(value.details),
        'rank': value.rank,
        'created_at': value.created_at,
        'status_set_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value.status_set_by_user),
        'receipt_id': value.receipt_id,
        'updates': value.updates === undefined ? undefined : ((value.updates as Array<any>).map(PalSubmissionListEntryLeadWaitlistUpdatesInnerToJSON)),
    };
}

